import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const BurgerMenu = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="24" height="24" viewBox="0 0 24 24" {...props}>
    <rect id="Rectangle_5930" data-name="Rectangle 5930" width="24" height="24" fill="none" />
    <path
      id="Path_24405"
      data-name="Path 24405"
      d="M3,18H21V16H3Zm0-5H21V11H3ZM3,6V8H21V6Z"
      fill="#0a1e55"
    />
  </Svg>
));

BurgerMenu.displayName = 'BurgerMenu';

export default BurgerMenu;
